import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';
import LogRocket from 'logrocket';
import moment from 'moment';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
};
const getUserId = () => firebase.auth().currentUser?.uid;
firebase.initializeApp(firebaseConfig);
const database = firebase.database();

export async function signIn(app) {
  let provider = '';
  if (app === 'google') {
    provider = new firebase.auth.GoogleAuthProvider();
  } else if (app === 'github') {
    provider = new firebase.auth.GithubAuthProvider();
  }
  await firebase.auth().signInWithRedirect(provider);
}
let userData = {};

firebase.getCurrentUser = () => new Promise((resolve, reject) => {
  const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
    console.log(user);
    unsubscribe();
    localStorage.setItem('user', user.uid);
    resolve(user);
  }, reject);
});
const getUserIdHelpMethod = () => {
  let userId = '';
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      userId = user.uid;
    }
  });
  return userId;
};


export async function pushToFirebase(key, data, withoutUser) {
  let userId = getUserId();
  if (!key || !data || !userId) {
    console.log('error in @ pushToFirebase @ because of key or id or user id', key, data);
    userId = getUserIdHelpMethod();
  }
  try {
    const responseElement = await database.ref(`${withoutUser ? '' : `${userId}/`}${key}`).push(data).then((response) => response.key);
    return responseElement;
  } catch (e) {
    console.log(e);
  }
  return '';
}
export async function setToFirebase(key, value) {
  let userId = getUserId();
  if (!key || !value || !userId) {
    console.log('error in @ setToFirebase @ because of key or id or user id', key, value);
    userId = getUserIdHelpMethod();
  }
  try {
    const item = await database.ref(`${userId}/${key}`).set(value);
    return item;
  } catch (e) {
    console.log(e);
  }
  return '';
}

export function getUserFirebaseStatus(callback) {
  return new Promise((resolve) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const isLocalhost = window.location.origin === 'http://localhost:8080';
        if (!isLocalhost) pushToFirebase('usersActivityLogs', { userId: user.uid, date: moment().toISOString(), origin: window.location.origin }, true);
        userData = user;
        localStorage.setItem('user', user.uid);
        LogRocket.identify(user.uid);
        setToFirebase('userAvatar', user.photoURL);
        if (callback) callback(user);
        resolve(userData);
        if (window.location.href.includes('signin')) window.location.reload(true);
      } else {
        resolve(false);
      }
    });
  });
}

export function logInAnon() {
  // const useLogin = localStorage.getItem('useLoginAnonimous');
  // if (useLogin) return alert('Twoje konto testowe jest już wykorzystane');
  return new Promise((resolve, reject) => {
    firebase.auth().signInAnonymously()
      .then(() => {
        localStorage.setItem('useLoginAnonimous', true);
        resolve();
        setTimeout(() => {
          window.location.reload(true);
        }, 2000);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
}

export function singOut() {
  return new Promise((resolve, reject) => {
    firebase.auth().signOut().then(() => {
      localStorage.setItem('user', '');
      console.log('wylogowano');
      resolve();
    }).catch((error) => {
      console.log(error);
      reject();
    });
  });
}

// New firebase functions //
export async function getFromFirebase(key, callback) {
  let userId = getUserId();
  if (!key || !userId) {
    console.log('error in @ getFromFirebase @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  try {
  // This function subscribe database key and listening changes
    await database.ref(`${userId}/${key}`).once('value', (snapshot) => {
      const firebaseArr = [];
      snapshot.forEach((firebaseItem) => {
        const firebaseObject = {
          ...firebaseItem.val(),
          firekey: firebaseItem.ref.key,
        };
        firebaseArr.push(firebaseObject);
      });
      callback(firebaseArr);
      return firebaseArr;
    });
  } catch (e) {
    console.log(e);
  }
  // This is how I can catch logs from the app.
}
export async function subscribeAddElement(key, callback) {
  let userId = getUserId();
  if (!key || !userId) {
    console.log('error in @ subscribeAddElement @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  try {
    await database.ref(`${userId}/${key}`).on('child_added', (data) => {
      const firebaseObject = {
        ...data.val(),
        firekey: data.ref.key,
      };
      callback(firebaseObject);
      return firebaseObject;
    });
  } catch (e) {
    console.log(e);
  }
}
// from anonimous accont to normal account
export async function mergeAnonimousAccount() {
  const user = firebase.auth().currentUser;
  console.log(user);
  const credential = firebase.auth.GoogleAuthProvider.credential(
    user.id_token,
  );
  firebase.auth.currentUser.linkWithCredential(credential)
    .then((usercred) => {
      const { newUser } = usercred;
      console.log('Anonymous account successfully upgraded', newUser);
    }).catch((error) => {
      console.log('Error upgrading anonymous account', error);
    });
}

export async function subscribeRemoveElement(key, callback) {
  let userId = getUserId();
  if (!key || !userId) {
    console.log('error in @ subscribeRemoveElement @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  database.ref(`${userId}/${key}`).on('child_removed', (data) => {
    const firebaseObject = {
      ...data.val(),
      firekey: data.ref.key,
    };
    callback(firebaseObject);
    return firebaseObject;
  });
}

// const CRUD = (path) => {
//   tutorialsRef.once('value', function(snapshot) {
//     vat tutorials = [];
//     snapshot.forEach(function(childSnapshot) {
//       var key = childSnapshot.key;
//       var data = childSnapshot.val();
//       // ...
//       tutorials.push({ key: key, title: data.title, description: data.description});
//     });
//   });
//   tutorialsRef.on('child_added', function(data) {
//     // data.key, data.val().title, data.val().description
//   });
//   tutorialsRef.on('child_changed', function(data) {
//     // data.key, data.val().title, data.val().description
//   });
//   tutorialsRef.on('child_removed', function(data) {
//     // data.key, data.val().title, data.val().description
//   });
//   tutorialsRef.off("value", onDataChange);
//   tutorialsRef.push({
//     title: "bezkoder Tut#1",
//     description: "Helpful tutorial"
//   });
// };

// tutorialsRef.on('child_changed', function(data) {
//   // data.key, data.val().title, data.val().description
// });
// tutorialsRef.on('child_removed', function(data) {
//   // data.key, data.val().title, data.val().description
// });

export async function removeItemFromFirebase(key, id) {
  let userId = getUserId();

  if (!key || !id || !userId) {
    console.log('error in @ removeItemFromFirebase @ because of key or id or user id', key, id);
    userId = getUserIdHelpMethod();
  }
  try {
    await database.ref(`${userId}/${key}`).child(id).remove();
  } catch (e) {
    console.log(e);
  }
}

export function updateItemInFirebase(key, item, withoutUser) {
  let userId = getUserId();

  if (!key || !item || !userId) {
    console.log('error in @ updateItemInFirebase @ because of key or id or user id', key, item);
    userId = getUserIdHelpMethod();
  }
  try {
    database.ref(`${withoutUser ? '' : `${userId}/`}${key}`).child(item.firekey).update({
      ...item,
    });
  } catch (e) {
    console.log(e);
  }
}

export async function getItemsFromFirebase(key) {
  let userId = getUserId();

  if (!key || !userId) {
    console.log('error in @ getItemsFromFirebase @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  try {
    const itemsArr = [];
    // It function get items once from database
    await database.ref(`${userId}/${key}`).once('value', (items) => {
      items.forEach((firebaseItem) => {
        if (typeof (firebaseItem.val()) === 'object') {
          itemsArr.push({
            ...firebaseItem.val(),
            firekey: firebaseItem.ref.key,
          });
        } else if (typeof (firebaseItem.val()) === 'string') {
          itemsArr.push({
            value: firebaseItem.val(),
            firekey: firebaseItem.ref.key,
          });
        }
      });
    });
    return itemsArr;
  } catch (e) {
    console.log(e);
    return e;
  }
}

export async function getItemFromFirebase(key, callback) {
  let userId = getUserId();
  if (!key || !userId) {
    console.log('error in @ getItemFromFirebase @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  // It function get item once from database
  try {
    database.ref(`${userId}/${key}`).on('value', (items) => {
      callback(items.val());
    });
  } catch (e) {
    console.log(e);
  }
}

export async function getElementFromFirebase(key, callback) {
  let userId = getUserId();

  if (!key || !userId) {
    console.log('error in @ getElementFromFirebase @ because of key or id or user id', key);
    userId = getUserIdHelpMethod();
  }
  try {
    const resposne = await database.ref(`${userId}/${key}`).on('value', (snap) => {
      const nick = snap.val();
      callback(nick);
      return nick;
    });
    return resposne;
  } catch (e) {
    console.log(e);
    return '';
  }
}

export async function getElementFromFirebaseByKey(key) {
  if (!key) return;
  try {
    await database.ref(`${key}`).on('value', (snapshot) => {
      const returnArr = [];
      if (snapshot) {
        snapshot.forEach((item) => {
          const itemData = item.val();
          returnArr.push({ ...itemData, fireKey: item.ref.key });
        });
        return returnArr;
      }
      return null;
    });
  } catch (e) {
    console.log(e);
  }
}

// const messaging = firebase.messaging();

// messaging.usePublicVapidKey(
// 'BB4FuI7IMe4W5yRepHogSIiP57YSJAbdRa3Yac04tx1zpJNjrNcoIaid2JIO6NU3lDaPdmkqXAnzR1f-TEmoCAI');
// setTimeout(() => {
//   // Request Permission of Notifications
//   messaging.requestPermission().then(() => {
//     console.log('Notification permission granted.');

//     // Get Token
//     messaging.getToken().then((token) => {
//       console.log(token);
//     });
//   }).catch((err) => {
//     console.log('Unable to get permission to notify.', err);
//   });
// }, 10 * 1000);

export default firebase;
